import React from 'react';
import { Box, Tooltip, IconButton, SvgIconProps } from '@mui/material';

export interface ActionColumn {
    icon: React.ComponentType<SvgIconProps>;
    tooltip: string;
    onClick?: (props: any) => void;
    iconWidth?: number;
    disabled?: boolean;
    componentProps?: {
        component: React.FC;
        [key: string]: any;
    };
}
export interface ActionsColumnProps {
    actions: ActionColumn[];
    [key: string]: any;
}
const ActionsColumn: React.FC<ActionsColumnProps> = ({ actions, ...props }) => {
    const iconsSX = { color: 'common.grey1', padding: '0 4px' };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {actions.map((action, index) => {
                const IconComponent = action.icon;
                return (
                    <Tooltip key={index} title={action.tooltip}>
                        <span>
                            <IconButton
                                data-testid='action-button'
                                aria-label={action.tooltip.toLowerCase()}
                                sx={iconsSX}
                                disabled={action.disabled}
                                {...(action.onClick ? { onClick: () => action.onClick && action.onClick(props) } : {})}
                                {...action.componentProps}
                            >
                                <IconComponent sx={{ width: `${action.iconWidth ?? 20}px` }} />
                            </IconButton>
                        </span>
                    </Tooltip>
                );
            })}
        </Box>
    );
};

export default ActionsColumn;
